import { RegisterState } from '../../store/state';
import { RegisterAction, RegisterActions } from '../actions';

const initialState: RegisterState = {
  registered: false,
  errorText: '',
  isLoading: false,
};

export default (state: RegisterState = initialState, action: RegisterAction) => {
  switch (action.type) {
    case RegisterActions.RegisterRequest:
      return {
        ...state,
        registered: false,
        errorText: '',
        isLoading: true,
      };
    case RegisterActions.RegisterSuccess:
      return {
        ...state,
        registered: true,
        errorText: '',
        isLoading: false,
      };
    case RegisterActions.RegisterError:
      return {
        ...state,
        registered: false,
        errorText: action.payload.errorText,
        isLoading: false,
      };
    default:
      return state;
  }
};


